import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
} from '@digital-retail/design-system';
import PropTypes from 'prop-types';
import { constants } from '../../config/constants';
import { noop } from '../../utils/noop';
import { ShippingPopOverStyles } from './ShippingPopOver.style';

const ShippingPopOver = ({ isOpen, deliveryType, onClose, children }) => {
  const message =
    deliveryType === constants.AVAILABILITY_EXPRESS
      ? 'Para esta cantidad, la entrega será con envío rápido.'
      : 'Para esta cantidad, la entrega será con envío programado.';
  return (
    <Popover isLazy placement="top" isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>{children}</PopoverTrigger>
      <Portal>
        <PopoverContent className="shipping-tooltip">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>Cambio en la entrega del producto</PopoverHeader>
          <PopoverBody>{message}</PopoverBody>
          <style jsx>{ShippingPopOverStyles}</style>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

ShippingPopOver.propTypes = {
  isOpen: PropTypes.bool,
  deliveryType: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
};

ShippingPopOver.defaultProps = {
  isOpen: false,
  deliveryType: '',
  onClose: noop,
};

export { ShippingPopOver };
